export function getAxiosErrorMessage(error, fallback = 'Request failed') {
    const response = error?.response;
    const data = response?.data;

    if (data && typeof data === 'object') {
        if (typeof data.error === 'string' && data.error.trim()) return data.error;
        if (typeof data.message === 'string' && data.message.trim()) return data.message;

        const errors = data.errors;
        if (errors && typeof errors === 'object') {
            const firstKey = Object.keys(errors)[0];
            const first = firstKey ? errors[firstKey] : null;
            if (Array.isArray(first) && first[0]) return first[0];
            if (typeof first === 'string' && first.trim()) return first;

            const messages = Object.values(errors).flat().filter(Boolean);
            if (messages.length) return messages.join(' ');
        }
    }

    if (typeof data === 'string' && data.trim()) return data;
    if (typeof error?.message === 'string' && error.message.trim()) return error.message;

    return fallback;
}

